function isConsentGranted(category: string): boolean {
    const settings = useCookieSettingsCookie().value as Record<string, string> | null

    return settings?.[category] === 'granted'
}

/**
 * Reads a consent category from the persisted cookie settings
 * (`pilulkaCookieSettings`, managed by the cookie bar). Returns true only when
 * the user has explicitly granted it — the default is denied (opt-in).
 */
export function isAnalyticsConsentGranted(): boolean {
    return isConsentGranted('analytics_storage')
}

export function isFunctionalityConsentGranted(): boolean {
    return isConsentGranted('functionality_storage')
}

export function isAdvertisingConsentGranted(): boolean {
    return isConsentGranted('ad_storage')
}
